import Api from './api'



export default {

    register: function (token, appInstanceId) {

        return Api.post('/v3/users/notification/push/register', { token, appInstanceId, device: 'web' })

    },

    update: function (data) {
        return Api.put('/v3/users/settings', {
            name: 'notifications',
            value: {
                push: data
            }
        })
    }
}

